import React, { useEffect, useRef } from 'react';

const SCRIPT_ID = 'cloudflare-turnstile-script';

const TurnstileWidget = ({ action, onVerify, onExpire }) => {
  const container = useRef(null);
  const widgetId = useRef(null);
  const verifyCallback = useRef(onVerify);
  const expireCallback = useRef(onExpire);
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  verifyCallback.current = onVerify;
  expireCallback.current = onExpire;

  useEffect(() => {
    if (!siteKey) {
      if (/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) verifyCallback.current?.('local-development');
      return undefined;
    }

    let cancelled = false;
    const render = () => {
      if (cancelled || !container.current || !window.turnstile || widgetId.current !== null) return;
      widgetId.current = window.turnstile.render(container.current, {
        sitekey: siteKey,
        action,
        theme: 'light',
        size: 'flexible',
        appearance: 'interaction-only',
        callback: (token) => verifyCallback.current?.(token),
        'expired-callback': () => { expireCallback.current?.(); verifyCallback.current?.(''); },
        'error-callback': () => { expireCallback.current?.(); verifyCallback.current?.(''); },
      });
    };

    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
    script.addEventListener('load', render);
    render();
    return () => {
      cancelled = true;
      script?.removeEventListener('load', render);
      if (window.turnstile && widgetId.current !== null) window.turnstile.remove(widgetId.current);
      widgetId.current = null;
    };
  }, [action, siteKey]);

  if (!siteKey && !/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    return <p className="text-sm text-red-600">Verifica antispam non configurata.</p>;
  }
  return <div ref={container} aria-label="Verifica antispam" />;
};

export default TurnstileWidget;
